import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    MonthSelectorDynamicStyle
} from "./type";
import type {
    Mutable
} from "../../types";
import {
    getCalendarCardStyle
} from "../dateSelector/stylesheet";

const stylesheet = StyleSheet.create({
    nextPrevToolContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    contentContainer: {
        flexDirection: "column"
    },
    rowContainer: {
        flexDirection: "row"
    },
    title: {
        textAlign: "center",
        flexShrink: 1
    },
    container: {
        alignSelf: "center"
    }
});

export const useStyles = ({
    controlHeights,
    shapeConfigs,
    isCardShown,
    isStretched,
    radiuses,
    borders,
    spaces,
    colors
}: MonthSelectorDynamicStyle) => {
    const styles = {
        nextPrevToolContainer: {
            marginBottom: spaces.spacingXs
        } as Mutable<ViewStyle>,
        container: getCalendarCardStyle({
            controlHeights,
            shapeConfigs,
            isCardShown,
            isStretched,
            radiuses,
            borders,
            spaces,
            colors
        }) as Mutable<ViewStyle>,
        contentContainer: {
            rowGap: spaces.spacingMd
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
